var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded && _vm.isVerified)?_c('PagePayoutsMain',{attrs:{"verification":_vm.verification}}):(_vm.isLoaded)?_c('PageVerification',{attrs:{"verification":_vm.verification}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }